import appConfigs from "@/configs";

function checkCryptoIsEnabled(requestPath: string): boolean {
  const cryptoSettings = appConfigs.cryptography;
  let isCryptoEnabled = true;

  if (cryptoSettings.includePathPatterns.length > 0 || cryptoSettings.includePaths.length > 0) {
    isCryptoEnabled = false;

    if (cryptoSettings.includePathPatterns.some((pattern) => wildcardMatch(requestPath, pattern))) {
      isCryptoEnabled = true;
    }

    if (cryptoSettings.includePaths.some((path) => path === requestPath)) {
      isCryptoEnabled = true;
    }
  }

  if (cryptoSettings.excludePathPatterns.length > 0 || cryptoSettings.excludePaths.length > 0) {
    isCryptoEnabled = true;

    if (cryptoSettings.excludePathPatterns.some((pattern) => wildcardMatch(requestPath, pattern))) {
      isCryptoEnabled = false;
    }

    if (cryptoSettings.excludePaths.some((path) => path === requestPath)) {
      isCryptoEnabled = false;
    }
  }

  return isCryptoEnabled && cryptoSettings.enabled;
}

function wildcardMatch(text: string, pattern: string): boolean {
  const regexPattern = new RegExp(`^${pattern.replace(/\?/g, ".").replace(/\*/g, ".*")}$`);

  return regexPattern.test(text);
}

export default checkCryptoIsEnabled;
